import { Fade } from '@mui/material'
import Backdrop from '@mui/material/Backdrop'
import CircularProgress from '@mui/material/CircularProgress'
import { memo } from 'react'

export default memo((props) => {
    const { show, fade } = props

    if (fade) {
        return (
            <Fade
                in={show}
                style={{
                    transitionDelay: show ? '175ms' : '600ms'
                }}
                unmountOnExit
            >
                <Backdrop
                    sx={{
                        color: '#fff',
                        zIndex: (theme) => theme.zIndex.drawer + 1
                    }}
                    open={true}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>
            </Fade>
        )
    }

    if (!show) {
        return null
    }
    return (
        <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={true}
        >
            <CircularProgress color="inherit" />
        </Backdrop>
    )
})
